import { Hud, GizmoHelper, GizmoViewport } from '@react-three/drei';
import { ThreeElements } from '@react-three/fiber';

type GizmoProps = ThreeElements['group'] & {
    margin?: [number, number];
    renderPriority?: number;
    autoClear?: boolean;
};

export const Gizmo = ({ margin = [88, 208], renderPriority = 1 }: GizmoProps) => {
    const [marginX, marginY] = margin;

    const colors = ['#ff4444', '#3B82F6', '#EAB308'] as [string, string, string];

    return (
        <Hud renderPriority={renderPriority}>
            <GizmoHelper alignment="bottom-right" margin={[marginX, marginY]} renderPriority={2}>
                <GizmoViewport
                    disabled
                    axisColors={[...colors]}
                    labelColor="white"
                    axisHeadScale={1.2}
                    labels={['Y', 'Z', 'X']}
                />
            </GizmoHelper>
        </Hud>
    );
};
